module.exports = __webpack_public_path__ + "img/2025-12-20a_2.e52d569e.gif";